window.devices = {

Apple: [
    "iPhone 16",
    "iPhone 15",
    "iPhone 14",
    "iPhone 13",
    "iPhone 12"
],

Samsung: [
    "Galaxy S25",
    "Galaxy S24",
    "Galaxy S23"
],

Google: [
    "Pixel 9",
    "Pixel 8"
],

Huawei: [
    "P40"
]

};

window.compatible = [

"iPhone 16",
"iPhone 15",
"iPhone 14",
"iPhone 13",
"Galaxy S25",
"Galaxy S24",
"Pixel 9"

];